import React, { Component } from "react";
import axios from "axios";
import { Container, Row, Col, Modal, Button, Form } from "react-bootstrap";
import "../../style-sheets/home.css";
import moment from "moment";
import { Checkbox, Select, TimePicker, Spin, Input, DatePicker } from "antd";
import { Link } from "react-router-dom";
import { agentCoRequest } from "../../global-state/actions/agentRequestAction";
import { getAreasAction } from "../../global-state/actions/courierAreaAction";

import ErrorHandler from "../../ErrorHandler/ErrorHandler";
//redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { changeOrderType } from "../../global-state/actions/changeTypeAction";
import { APILINK } from "../../Endpoint";
import isEqual from "lodash/isEqual";

const axiosApiInstance = axios.create();

class SearchCouriers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allVehicles: [],
      allServices: [],
      approval_need: "",
      provide_wallet: "",
      price: "",
      selectedData: "",
      selectedVehiclesId: [],
      selectedServicesId: [],
      selectedTime: "",
      areas: [],
      emirates: [],
      selectedPickArea: "",
      selectedDropArea: "",
      quantity: +props.details.pre_request.product_quantity,
      selectedPickEmirate: "",
      selectedDropEmirate: "",
    };
  }

  calcPrice() {
    this.setState({
      totalPrice: this.state.quantity * +this.props.details.yanzo_price,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!isEqual(prevState, this.state)) {
      if (
        this.state.selectedPickArea !== "" ||
        this.state.selectedDropArea !== ""
      ) {
        this.setState({ showWarning: false });
      }
    }
    if (prevState.quantity !== this.state.quantity) {
      this.calcPrice();
    }
  }

  onClose = (e) => {
    this.props.hideCourier(false);
  };
  onHandleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  getVehicles = async () => {
    // Request interceptor for API calls

    // console.log(newID);
    const result = await axiosApiInstance.get(APILINK + `/vehicle_types/`);
    if (result) {
      this.setState({ allVehicles: result.data });
    }
  };

  getService = async () => {
    // Request interceptor for API calls

    // console.log(newID);
    const result = await axiosApiInstance.get(APILINK + `/delivery_service`);
    if (result) {
      this.setState({ allServices: result.data.data });
    }
  };

  handleTime = (time, timeString) => {
    this.setState({ selectedTime: timeString });
  };

  handleVehicles = (e) => {
    this.setState({
      selectedVehicles: e,
      selectedVehiclesId: e,
    });
    // console.log(e);
  };
  handleServices = (e) => {
    this.setState({
      selectedServices: e,
      selectedServicesId: e,
    });
    console.log(e);
  };
  handleSubmitData = (e) => {
    this.setState({
      selectedData: e,
    });
    console.log(e);
  };
  handleWallet = (e) => {
    console.log(`checked = ${e.target.checked}`);
    this.setState({ provide_wallet: e.target.checked });
  };
  handleApproval = (e) => {
    console.log(`checked = ${e.target.checked}`);
    this.setState({ approval_need: e.target.checked });
  };

  onCoSearch = async () => {
    if (
      this.state.selectedDropArea == "" &&
      this.state.selectedPickArea == ""
    ) {
      this.setState({ showSpinner: false, showWarning: true });
      console.log("trueeeeeeee");
    } else {
      this.setState({ showSpinner: true });
      let vehicle = this.state.selectedVehiclesId
        .toString()
        .replace(/-/g, "")
        .replace(/,/g, "__");
      let service = this.state.selectedServicesId
        .toString()
        .replace(/-/g, "")
        .replace(/,/g, "__");
      let area = [this.state.selectedPickArea, this.state.selectedDropArea]
        .toString()
        .replace(/-/g, "")
        .replace(/,/g, "__");

      let link =
        APILINK +
        `/courier_services/?vehicle__in=${vehicle}&delivery__in=${service}&price__lte=${
          this.state.price
        }&provide_wallet=${
          this.state.provide_wallet
        }&pick_up_area=${this.state.selectedPickArea.replaceAll(
          "-",
          ""
        )}&drop_off_area=${this.state.selectedDropArea.replaceAll("-", "")}`;
      console.log(link);
      // link =
      //   APILINK +
      //   `/courier_services/?vehicle=${x}&delivery=${z}&price=${this.state.price}&provide_wallet=${this.state.provide_wallet}`;
      // if (
      //   this.state.selectedVehiclesId.length === 1 &&
      //   this.state.selectedServicesId.length === 1
      // ) {
      //   let x = this.state.selectedVehiclesId.toString();
      //   let y = this.state.selectedServicesId.toString();
      //   let z = y.replace(/-/g, "");
      //   link =
      //     APILINK +
      //     `/courier_services/?vehicle=${x}&delivery=${z}&price=${this.state.price}&provide_wallet=${this.state.provide_wallet}`;
      // } else if (
      //   this.state.selectedVehiclesId.length === 1 &&
      //   this.state.selectedServicesId.length !== 1
      // ) {
      //   let x = this.state.selectedServicesId.toString();
      //   var res = x.replace(/,/g, "__");
      //   console.log(res);
      //   let z = res.replace(/-/g, "");
      //   console.log(z);
      //   let y = this.state.selectedVehiclesId.toString();

      //   link =
      //     APILINK +
      //     `/courier_services/?vehicle=${y}&delivery__in=${z}&price=${this.state.price}&provide_wallet=${this.state.provide_wallet}`;
      // } else if (
      //   this.state.selectedVehiclesId.length !== 1 &&
      //   this.state.selectedServicesId.length === 1
      // ) {
      //   let x = this.state.selectedVehiclesId.toString();
      //   var res = x.replace(/,/g, "__");

      //   // console.log(res);
      //   let y = this.state.selectedServicesId.toString();
      //   let z = y.replace(/-/g, "");

      //   link =
      //     APILINK +
      //     `/courier_services/?vehicle__in=${res}&delivery=${z}&price=${this.state.price}&provide_wallet=${this.state.provide_wallet}`;
      // } else if (
      //   this.state.selectedVehiclesId.length === 0 ||
      //   this.state.selectedServicesId.length === 0
      // ) {
      //   link =
      //     APILINK +
      //     `/courier_services/?price=${this.state.price}&provide_wallet=${this.state.provide_wallet}`;
      // } else {
      //   //to take selected values lw hya aktr mn haga f array , make them string and seperate between them with __ to send it inside request params
      //   let x = this.state.selectedVehiclesId.toString();
      //   var res = x.replace(/,/g, "__");

      //   let y = this.state.selectedServicesId.toString();
      //   var res2 = y.replace(/,/g, "__");
      //   let z = res2.replace(/-/g, "");

      //   link =
      //     APILINK +
      //     `/courier_services/?vehicle__in=${res}&delivery__in=${z}&price=${this.state.price}&provide_wallet=${this.state.provide_wallet}`;
      // }
      console.log({ details: this.props.details });
      const result = await axiosApiInstance.get(`${link}`);
      if (result) {
        console.log(result);
        this.props.changeOrderType("1");
        this.props.agentCoRequest(result.data);
        this.props.getAreasAction({
          areas: [
            this.state.selectedPickAreaNum,
            this.state.selectedDropAreaNum,
          ],
          emirates: [
            this.state.selectedPickEmirate,
            this.state.selectedDropEmirate,
          ],
          quantity: this.state.quantity,
          delivery_date: `${this.state.scheduledDate}T${this.state.selectedTime}`,

          price: this.state.totalPrice,
          notes: this.state.notes,
        });

        setTimeout(() => {
          window.location.assign(`/view_couriers`);
        }, 1000);
      }
    }
  };
  handleDate1 = (date, dateString) => {
    this.setState({ scheduledDate: dateString });
  };

  componentDidMount() {
    this.calcPrice();
    this.getVehicles();
    this.getService();
    this.getEmirates();
    this.getAreas();
  }

  getEmirates = async () => {
    const result = await axiosApiInstance.get(APILINK + "/emirate?limit=1000");
    this.setState({ emirates: result.data.results });
  };
  getAreas = async (e) => {
    const result = await axiosApiInstance.get(APILINK + `/areas/${e}`);
    console.log(result);
    this.setState({ areas: result.data });
  };

  render() {
    console.log(this.state.selectedPickEmirate, this.state.selectedDropEmirate);
    return (
      <Modal show={this.props.show} onHide={this.onClose}>
        <Container className="p-3">
          <Row>
            <Col sm={12}>
              <h6>Search For Couriers</h6>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col sm="12" md="6">
              <Form.Label>Pick up Emirates</Form.Label>

              <Select
                placeholder="Select Emirate"
                style={{ width: "100%" }}
                // showSearch
                onChange={(e, v) => {
                  this.getAreas(e);
                  this.setState({
                    selectedPickEmirate: v.name,
                  });
                }}
              >
                {this.state.emirates?.map((item) => (
                  <Select.Option value={item.id} name={item.num}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col sm="12" md="6">
              <Form.Label>Pick up Areas</Form.Label>

              <Select
                placeholder="Select Area"
                style={{ width: "100%" }}
                // showSearch
                onChange={(e) =>
                  this.setState({
                    selectedPickArea: this.state.areas[e].id,
                    selectedPickAreaNum: this.state.areas[e].num,
                  })
                }
              >
                {this.state.areas?.map((item, i) => (
                  <Select.Option value={i} name={item.name}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col sm="12" md="6">
              <Form.Label>Drop off Emirates</Form.Label>

              <Select
                placeholder="Select Emirate"
                style={{ width: "100%" }}
                // showSearch
                onChange={(e, v) => {
                  this.getAreas(e);
                  this.setState({
                    selectedDropEmirate: v.name,
                  });
                }}
              >
                {this.state.emirates?.map((item) => (
                  <Select.Option value={item.id} name={item.num}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Col>
            <Col sm="12" md="6">
              <Form.Label>Drop off Areas</Form.Label>

              <Select
                placeholder="Select Area"
                style={{ width: "100%" }}
                // showSearch
                onChange={(e) =>
                  this.setState({
                    selectedDropArea: this.state.areas[e].id,
                    selectedDropAreaNum: this.state.areas[e].num,
                  })
                }
              >
                {this.state.areas?.map((item, i) => (
                  <Select.Option value={i} name={item.name}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col sm={12} md={12}>
              <Form.Label>Vehicles</Form.Label>
              <Select
                mode="multiple"
                showSearch
                placeholder="Select Vehicles"
                value={this.state.selectedVehicles}
                // labelInValue
                onChange={this.handleVehicles}
                style={{ width: "100%" }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.allVehicles.map((item) => (
                  <Select.Option key={item.id} name={item.name} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col sm={12} md={12}>
              <Form.Label>Delivery Services</Form.Label>

              <Select
                mode="multiple"
                showSearch
                // labelInValue
                placeholder="select services"
                value={this.state.selectedServices}
                onChange={this.handleServices}
                style={{ width: "100%" }}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
              >
                {this.state.allServices.map((item) => (
                  <Select.Option name={item.name} key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
              </Select>
            </Col>
          </Row>
          <Row className="mb-1">
            <Col sm={12} md={12}>
              <Form.Label>Delivery Date</Form.Label>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col sm={12} md={12}>
              <DatePicker
                onChange={this.handleDate1}
                format="YYYY-MM-DD"
                required
              />
              {/* {this.state.selectedDate == "" &&
                    this.state.errorHandel !== "" ? (
                      <p className="errorHandel">{this.state.errorHandel}</p>
                    ) : null} */}
            </Col>
          </Row>
          <Row className="mb-1">
            <Col sm={12} md={12}>
              <Form.Label>Delivery Time</Form.Label>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col sm={12} md={12}>
              <TimePicker
                onChange={this.handleTime}
                defaultOpenValue={moment("00:00:00", "HH:mm:ss")}
              />
            </Col>
          </Row>
          <Row className="mb-3">
            <Col sm={6} md={6}>
              <Form.Label>Quantity</Form.Label>
              <Input
                type={"number"}
                min={1}
                id={"quantity"}
                name={"quantity"}
                placeholder="Quantity"
                value={this.state.quantity}
                onChange={(e) => this.setState({ quantity: e.target.value })}
                style={{ width: "100%" }}
              />
            </Col>
            <Col sm={6} md={6}>
              <Form.Label>Total Price</Form.Label>

              <Input
                min={0}
                type={"number"}
                id={"price"}
                name={"price"}
                placeholder="Price"
                value={this.state.totalPrice ?? 0}
                onChange={(e) => this.setState({ totalPrice: e.target.value })}
                style={{ width: "100%" }}
              />
            </Col>
          </Row>
          <Row className="mb-3">
            <Col sm={12} md={12}>
              <Form.Label>Notes</Form.Label>

              <Input
                id={"notes"}
                name={"notes"}
                placeholder="Notes"
                value={this.state.notes}
                onChange={(e) => this.setState({ notes: e.target.value })}
                style={{ width: "100%" }}
              />
            </Col>
          </Row>
          <Row className="my-2">
            <Col sm={12} md={6}>
              <Checkbox onChange={this.handleWallet}>Provide Wallet</Checkbox>
            </Col>
            {/* <Col sm={12} md={6}>
              <Checkbox onChange={this.handleApproval}>
                Approval Need
              </Checkbox>
            </Col> */}
          </Row>
          <Row>
            <Col style={{ textAlign: "right" }} sm={12} md={12}>
              {/* <Link to={"/view_couriers"}> */}
              {this.state.showSpinner ? <Spin tip="Loading..."></Spin> : null}
              <Button onClick={this.onCoSearch} className="supplierBtn">
                Search
              </Button>
              {/* </Link> */}
            </Col>
          </Row>
          {this.state.showWarning ? (
            <p className="errorHandel text-center">
              You must choose emirates and it's related pick up and drop off
              areas
            </p>
          ) : null}
        </Container>{" "}
      </Modal>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    { agentCoRequest, changeOrderType, getAreasAction },
    dispatch
  );
};
export default connect(
  null,
  mapDispatchToProps
)(ErrorHandler(SearchCouriers, axiosApiInstance));
